import { Link } from "../router";
import { LEGAL_NAV } from "./LegalPage";

export function Footer({ agreementVersion }: { agreementVersion?: string }) {
  return (
    <footer className="footer">
      <span className="sub">
        Florida county and municipal public records, refreshed each morning.
        Scores are our estimates, not official determinations; milestone status
        is labelled with its source.
      </span>
      <div className="spacer" />
      <nav aria-label="Legal">
        {/* The company, not the product. Kept out of the legal nav above
            because it is attribution, not a document anyone accepted. */}
        <a
          className="linkbtn poweredby"
          href="https://dtrworks.net"
          target="_blank"
          rel="noreferrer noopener"
        >
          Powered by <strong>DTR Works</strong>
        </a>
        <Link to="/coverage" className="linkbtn">
          Coverage
        </Link>
        <Link to="/methodology" className="linkbtn">
          How scoring works
        </Link>
        <Link to="/pricing" className="linkbtn">
          How reports are priced
        </Link>
        {LEGAL_NAV.map((item) => (
          <Link key={item.path} to={item.path} className="linkbtn">
            {item.label}
          </Link>
        ))}
        {agreementVersion && <span className="sub">v{agreementVersion}</span>}
      </nav>
    </footer>
  );
}
